import axiosInstance from "../utils/axios";

export const GetUsersList = async (values) => {
    return await axiosInstance().post("admin/get-all-users", values);
}
export const GetSingleUser = async (values) => {
    return await axiosInstance().post("admin/get-single-user", values);
}

